import * as React from 'react';
import 'jsoneditor-react/es/editor.min.css';
import { useRecoilValue } from 'recoil';
import { widgetState, selectedCardState } from './DashboardState';

const JsonEditor = React.lazy(() =>
  import('jsoneditor-react').then(module => ({ default: module.JsonEditor }))
);

interface WidgetFormProps {
  onSubmit: (data: any) => any;
  onCancel: () => any;
}

export const WidgetForm: React.FC<WidgetFormProps> = ({
  onSubmit,
  onCancel,
}) => {
  const widgets = useRecoilValue(widgetState);
  const selectedCard = useRecoilValue(selectedCardState);
  const [modifiedWidget, setModifiedWidget] = React.useState(false);
  const [nextWidget, setNextWidget] = React.useState<any>(null);
  const [widget, setWidget] = React.useState<any>({});
  const setWidgetNameByID = (id: string) => {
    if (id) {
      //    console.log(id);
      const findWidget = widgets.find(widget => widget.id === id);
      if (typeof findWidget !== 'undefined') {
        setWidget({
          id: findWidget.id,
          data: findWidget.data,
          sseUrl: findWidget.sseUrl,
          options: findWidget.options,
          name: findWidget.name,
        });
      }
    }
  };

  React.useEffect(() => {
    if (selectedCard) {
      setWidgetNameByID(selectedCard.widgetId);
    }
  }, [selectedCard]);

  React.useEffect(() => {
    if (nextWidget) {
      setWidget(null);
    }
  }, [nextWidget]);

  React.useEffect(() => {
    if (widget === null && nextWidget) {
      setWidgetNameByID(nextWidget);
      setNextWidget(null);
    }
  }, [widget]);

  const handleSubmit = (event: { preventDefault: () => void }) => {
    if (event) {
      event.preventDefault();
    }

    if (typeof widget.id === 'undefined') {
      return;
    }

    onSubmit({ id: widget.id, name: widget.name, modifiedWidget });
  };

  return (
    <form className="id-w-full" onSubmit={handleSubmit}>
      <div className="id-flex id-flex-wrap id--mx-3 id-mb-6">
        <div className="id-w-full id-px-3">
          <label
            className="id-block id-uppercase id-tracking-wide id-text-gray-700 id-text-xs id-font-bold id-mb-2"
            htmlFor="grid-password"
          >
            Widget Type
          </label>
          <div className="id-relative">
            <select
              className="id-block id-appearance-none id-w-full id-bg-gray-200 id-border id-border-gray-200 id-text-gray-700 id-py-3 id-px-4 id-pr-8 id-rounded id-leading-tight focus:id-outline-none focus:id-bg-white focus:id-border-gray-500"
              id="grid-state"
              defaultValue={selectedCard ? selectedCard.widgetId : ''}
              onChange={e => {
                setNextWidget(e.target.value);
              }}
            >
              <option value={undefined}>None</option>
              {widgets.map(item => {
                return (
                  <option key={item.name} value={item.id}>
                    {item.name}
                  </option>
                );
              })}
            </select>
            <div className="id-pointer-events-none id-absolute id-inset-y-0 id-right-0 id-flex id-items-center id-px-2 id-text-gray-700">
              <svg
                className="id-fill-current id-h-4 id-w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      {widget && (
        <div className="id-flex id-flex-wrap id--mx-3 id-mb-6">
          <div className="id-w-full id-px-3">
            <label
              className="id-block id-uppercase id-tracking-wide id-text-gray-700 id-text-xs id-font-bold id-mb-2"
              htmlFor="grid-first-name"
            >
              Configuration
            </label>
            {typeof widget.id !== 'undefined' &&
              (typeof widget.data !== 'undefined' ||
                typeof widget.options !== 'undefined') && (
                <React.Suspense fallback="loading ...">
                  <div className="id-h-40 id-overflow-y-scroll">
                    <JsonEditor
                      value={{
                        data: widget.data,
                        options: widget.options,
                        sseUrl: widget.sseUrl,
                      }}
                      onChange={(d: any) => {
                        setModifiedWidget({ id: widget.id, ...d });
                      }}
                    />
                  </div>
                </React.Suspense>
              )}
          </div>
        </div>
      )}

      <div className="id-flex id-flex-wrap id--mx-3 id-mb-2">
        <div className="id-w-full id-pt-4 id-text-center id-align-middle">
          <button
            className="id-shadow id-bg-gray-800 hover:id-bg-gray-700 focus:id-shadow-outline focus:id-outline-none id-text-white id-font-bold id-p-2  id-m-2 id-rounded"
            type="submit"
          >
            Save
          </button>
          <button
            className="id-shadow id-bg-gray-800 hover:id-bg-gray-700 focus:id-shadow-outline focus:id-outline-none id-text-white id-font-bold id-p-2 id-m-2 id-rounded"
            type="button"
            onClick={() => onCancel()}
          >
            Cancel
          </button>
        </div>
      </div>
    </form>
  );
};
